import type { CategoriesV2 } from "storefront/Categories";
import type { SizesByCategoryV2 } from "storefront/Size";
import {
  get as getFromCache,
  put as putToCache,
} from "storefront/lib/memoryCache";
import { camelize } from "camelscore";
import { get } from "../../request";

export const CACHE_KEY = "get_listing_categories_from_config";

export type ResponseData = {
  categories: CategoriesV2;
  sizes: SizesByCategoryV2;
};

type Response = {
  data: ResponseData;
};

const unpack = ({ data }: Response): ResponseData => data;

if (typeof window !== "undefined" && window.CATEGORY_DATA) {
  putToCache(CACHE_KEY, camelize(window.CATEGORY_DATA));
}

const getCategories = (): Promise<ResponseData> => {
  const cachedValue = getFromCache(CACHE_KEY);
  if (cachedValue) {
    return Promise.resolve(cachedValue);
  }
  return get<Response>("/api/config/categories").then((response) => {
    const data = unpack(response);
    putToCache(CACHE_KEY, data);
    return data;
  });
};

export default getCategories;
